<template>
  <div>
    <section v-for="category in categories" :key="category.id" class="rtl mb-3">
      <!-- Heading-->
      <div style="background: #ffffff; padding:20px 0;border-radius:5px;">
        <div class="flex-between pl-4">
          <div class="category-product-view-title">
            <span class="for-feature-title float-left"
              style="font-weight: 700;font-size: 20px;text-transform: uppercase;text-align:left;">
              {{ dt(category['name_translations'], locale) }}
            </span>
          </div>
          <div class="category-product-view-all">
            <a hidden class="text-capitalize view-all-text" href="#">
              {{ t("global.viewAll") }}
              <i class="czi-arrow-right-circle ml-1 mr-n1"></i>
            </a>
          </div>
        </div>

        <div class="row mt-2 mb-3 d-flex justify-content-between">
          <div v-if="!!category.banner_media_id" class="col-md-3 col-12 pl-3 pr-3">
            <a :href="`/${routeCategoryPath}/${category.id}`" style="cursor: pointer;">
              <img class="" style="width: 100%; border-radius:5px;height: 300px;"
                onerror="this.src='/static/assets/front-end/img/image-place-holder.png'" :src="category.banner_media.url">
            </a>
          </div>
          <div class="col-12" :class="!!category.banner_media_id ? 'col-md-9' : 'col-md-12'">
            <div class="row d-flex">
              <div v-for="prom in category.proms" :key="prom.id" class="col-6 mt-2 mt-md-0"
                :class="!!category.banner_media_id ? 'col-md-4' : 'col-md-3'">
                <PromotionItem :promotion="prom" is-owl @view="onClickView" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div hidden v-for="category in categories" :key="category.id" class="container mb-4">
      <div class="row" style="background: white;box-shadow: 0px 3px 6px #0000000d;border-radius: 5px;">
        <div class="col-md-12">
          <div class="feature-product-title">
            {{ dt(category['name_translations'], locale) }}
          </div>
        </div>
        <div class="col-md-12">
          <div class="feature-product" style="padding-left:55px;padding-right: 55px;padding-top: 10px;">
            <div class="carousel-wrap p-1">
              <div class="promotion-carousel owl-carousel owl-theme">
                <PromotionItem v-for="prom in category.proms" :key="prom.id" :promotion="prom" is-owl
                  @view="onClickView" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <promotion-quick-view v-if="dialogVisible" v-model="dialogVisible" :promotion="promotion" />
  </div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { dataTranslations as dt, breakpoint } from "../../utils"
import PromotionItem from "./PromotionItem.vue"
import PromotionQuickView from "./PromotionQuickView.vue"

const props = defineProps({
  categories: Array
})

const { t, n, locale } = useI18n()

const AIBWebsiteType = computed(() => window.AIBWebsiteType);
const routeCategoryPath = computed(() => AIBWebsiteType.value === 'saas' ? 'app-market' : 'categories');

const itemsToShow = computed(() => {
  if (breakpoint.value.xs) {
    return 1
  } else if (breakpoint.value.sm) {
    return 2
  } else if (breakpoint.value.md) {
    return 3
  } else if (breakpoint.value.lg) {
    return 4
  }
  return 5
})
const dialogVisible = ref(false)
const promotion = ref(null)

const onClickView = (item) => {
  promotion.value = item
  dialogVisible.value = true
}
</script>
